import * as React from 'react';
import { MenuGroup } from "@elsa-zku/lib/components/Sidebar";

export type SidebarContext = {
  selectedBuildingId: number,
  onlyForReports: boolean,
}

const buildingForCalculation = (context: SidebarContext) => !!context.selectedBuildingId && !context.onlyForReports;
const buildingForReports = (context: SidebarContext) => !!context.selectedBuildingId && context.onlyForReports;

const menu: MenuGroup<SidebarContext>[] = [
  {
    title: 'Расчет отопления',
    items: [
      {
        url:   "/buildings",
        title: "Список домов",
        icon:  require("feather-icons/dist/icons/list.svg"),
      },
      {
        // url:   ({ selectedBuildingId }) => `/building/${selectedBuildingId}/apartments`,
        url:      '/apartments',
        title:    "Помещения",
        icon:     require("feather-icons/dist/icons/codepen.svg"),
        isActive: buildingForCalculation,
      },
      {
        url:      "/devices",
        title:    "Показания РТЭ",
        icon:     require("feather-icons/dist/icons/server.svg"),
        isActive: buildingForCalculation,
      },

      {
        url:      "/calculations",
        title:    "Расчеты",
        icon:     require("feather-icons/dist/icons/monitor.svg"),
        isActive: buildingForCalculation,
      },
      {
        url:      "/corrections",
        title:    "Корректировка",
        icon:     require("feather-icons/dist/icons/edit.svg"),
        isActive: buildingForCalculation,
      },
      {
        url:      "/final-calculations",
        title:    "Поквартирн. отчеты",
        icon:     require("feather-icons/dist/icons/codesandbox.svg"),
        isActive: buildingForReports,
      },
    ]
  },
  {
    title: 'Импорт показаний',
    items: [
      {
        url:      "/values-import",
        title:    "Импорт Excel",
        icon:     require("feather-icons/dist/icons/table.svg"),
        isActive: buildingForCalculation,
      },
      {
        url:      "/xml-import",
        title:    "Импорт XML",
        icon:     require("feather-icons/dist/icons/code.svg"),
        isActive: buildingForCalculation,
      },
    ]
  },

];

export default menu;
